module.exports = __webpack_public_path__ + "img/map_Z2.1.F.06.eac47f7d.svg";